module.exports = "/_next/static/images/FreePlan-sm@2x-0d8e73216ca2daf0d337bae037537396.webp";